module.exports = __webpack_public_path__ + "img/nan.0adf1748.png";